export default {
  Sending_succeeded: '發送成功',
  old_password_no: '舊密碼不允許為空白',
  New_password_no: '新密碼不能為空白，由6~16位數位和英文組成！',
  Confirm_new_password: '確認新密碼不能為空白，由6~16位數字和英文組成！',
  re_enter: '2次輸入不一致，請重新輸入',
  no_identical: '新密碼和原密碼不能相同',
  up_password_success: '密碼修改成功',
  Old_password_error: '舊密碼錯誤',
  modify_successfully: '修改成功',
  up_Phone: '手機號碼修改成功',
  modify_phone: '修改手機號碼',
  dialog_tips: '確定要修改手機號碼嗎？ 確定後，會先驗證舊手機號碼。 驗證通過後，再驗證新手機號碼',
  old_phone_code: '輸入舊手機號碼驗證碼',
  Modify_contact_name: '修改聯繫人姓名',
  Modify_agent_name: '修改代理商名稱',
  Modify_renewal_fs: '修改續費聯繫方式',
  Modify_detailed_address: '修改詳細地址',
  org_name: '修改公司名稱',
  verifying_phone: '正在驗證新手機號碼...',
  verifying_phone_tow: '正在驗證舊手機號碼...',
  code_success: '驗證碼發送成功',
  import_phone: '輸入新手機號碼驗證碼',
  Sending_verification_code: '正在發送驗證碼...',
  old_password_yes: '舊手機號碼驗證通過',
  New_mobile_number: '新手機號碼',
  Entera_new_phone: '輸入新手機號碼',
  Renewal_contact_information: '續費聯繫方式',
  Account_security: ' 為了保障您帳號安全，請先完善個人資訊',
  take_back: '收回',
  Reset_succeeded: '重置成功',
  row_passwords: '兩次輸入的密碼不一致',
  user_password_no: '用戶名稱或密碼不能為空白',
  //共用
  Loggingin: '登錄中...',
  country: '請選擇地區',
  country1: '選擇地區',
  loading: '載入中...',
  create_successfully: '創建成功！',
  Pleaseselectanagentfirst: '請先選擇代理商',
  Theminimumsalesquantitysonepiece: '銷售數量最小為一張',
  Pleaseselectservicecardtype: '請選擇服務卡類型',
  Insufficientvoicecardbalance: '語音卡餘額不足',
  Recordingcardbalanceisinsufficient: '錄音卡餘額不足',
  Insufficientbalanceoflocationcard: '定位卡餘額不足',
  InsufficientSOScardbalance: 'SOS卡餘額不足',
  Fencecardbalanceisinsufficient: '圍欄卡餘額不足',
  Insufficientvideocardbalance: '視頻卡餘額不足',
  Theduplexcardbalanceisinsufficient: '雙工卡餘額不足',
  Insufficientbalanceonvipcard: 'VIP卡餘額不足',
  Confirmsalesinformation: '確認銷售資訊',
  servicecardpasswordmistake: '輸入的服務卡密碼格式錯誤',
  Servicecardpasswordinputerror: '服務卡密碼輸入錯誤',
  successfulsales: '銷售成功',
  Pleaseselecttheunitfirst: '請先選擇公司',
  Yourinputisemptypleasereenter: '您的輸入為空白，請重新輸入！',
  Theenteredimeinumberisempty: '您輸入的IMEI號碼有誤，請重新輸入！',
  Donotaddrepeatedly: '請勿重複添加！',
  TheQRcodeiswrong: '二維碼有誤',
  TheIMEInumberiswrong: '您掃入的IMEI號碼有誤，請重新掃碼！',
  Donotscanthecoderepeatedly: '請勿重複掃碼',
  Pleaseselectausertype: '請選擇用戶類型！',
  Pleaseselectaunit: '請選擇公司',
  Userprefixnicknamecannotbeempty: '用戶前缀暱稱不能為空白！',
  nicknameNoXhx: '用戶前綴呢稱由2-26位字元組成',
  PleaseaddIMEInumber: '請添加IMEI號碼！',
  YoucanadduptoIMEIsbyscanningthecode: '掃碼最多可以添加100個IMEI！',
  YouhaverepeatedlyaddedIMEIpleasedeleteit: '您有重複添加的IMEI，請刪除！',
  Yourvoicecardisinsufficient: '您的語音卡不足，請先充值！',
  Yourrecordingcardisinsufficient: '您的錄音卡不足，請先充值！',
  Yourlocationcardisinsufficient: '您的定位卡不足，請先充值！',
  YourSOScardisinsufficient: '您的SOS卡不足，請先充值！',
  Yourfencecardisinsufficient: '您的圍欄卡不足，請先充值！',
  Yourvideocardisinsufficient: '您的視頻卡不足，請先充值！',
  Yourduplexcardisnotenough: '您的雙工卡不足，請先充值！',
  Theservicecardpasswordenteredisinthewrongformat: '輸入的服務卡密碼格式錯誤',
  Pleaseselectaregion: '請選擇區域',
  Changeemailaddress: '修改郵件地址',
  Editdetailedaddress: '編輯詳細地址',
  Bindingplatformisenabled: '已開啟綁定平台',
  Bindingplatformhasbeenclosed: '已關閉綁定平台',
  Memberdisplayturnedon: '已開啟成員顯示',
  Memberdisplayturnedoff: '已關閉成員顯示',
  Noisecancellationturnedon: '已開啟降噪功能',
  Noisecancellationturnedoff: '已關閉降噪功能',
  deleteOrg: '確認刪除該公司資訊嗎？',
  successfullydeleted: '刪除成功',
  successfullyset: '設置成功',
  Thisgroupisalreadythedefaultgroup: '該群組已經是預設群組！',
  deletedUserGroup: '確認移除用戶所屬群組嗎？',
  deletedGroup: '確認刪除該群組嗎？',
  Youhavenotmodifiedthenoteinformation: '您未修改備註資訊',
  Areyousureyouwanttoremovethismember: '確認移除該成員嗎？',
  Pleaseselectamembertoadd: '請選擇要添加的成員',
  Memberaddedsuccessfully: '成員添加成功',
  Theservicecardpasswordentered: '輸入的服務卡密碼格式錯誤',
  Thepasswordsenteredtwiceareinconsistent: '兩次輸入的密碼不一致，請重新輸入',
  successfullyopened: '開通成功！',
  Modifycontactnumber: '修改聯繫電話',
  Changeemailaddress: '修改郵件地址',
  Modifymailingaddress: '修改通訊地址',
  changeusername: '修改暱稱',
  Outofwarrantyandcannotbereplaced: '已過保修期，無法更換',
  Recycledsuccessfully: '回收成功',
  restarttheterminaltotakeeffect: '修改成功，重啟設備生效！',
  UserTalkbackSuspended: '已暫停用戶對講功能',
  Theuserintercomfunctionisturnedon: '已開啟用戶對講功能',
  shakeoff: '遠端開啟',
  Shaketodeath: '遠端關閉',
  Unitdispatcherison: '公司調度員已開啟',
  Unitdispatcherisclosed: '公司調度員已關閉',
  Changeuseraffiliation: "確定要改變用戶所屬公司嗎？",
  Pleaseselectauser: '請選擇用戶',
  PleaseentertheoldIMEIcorrectly: '請正確輸入15位舊IMEI',
  PleaseenterthenewIMEIcorrectly: '請正確輸入15位新IMEI',
  Replacedthecardsuccessfully: '换卡成功',
  TheoriginalIMEIentereddoesnotexist: '輸入的原IMEI不存在',
  TheenterednewIMEIisalreadyinuse: '輸入的新IMEI已經被使用',
  Cardreplacementfailed: '換卡失敗',
  Theverificationcodehasexpiredpleasegetitagain: '驗證碼已失效，請重新獲取！',
  Pleaseentercorrectverifycode: '請輸入正確的驗證碼！',
  Verificationcodeerror: '驗證碼錯誤！',
  Pleaseenteramobilephonenumberinthecorrectformat: '請輸入正確格式的手機號碼',
  Pleaseselectthelisteninggrouptobeadded: '請選擇需要添加的監聽群組',
  Confirmtoaddlisteninggroup: '確認添加監聽群組？',
  Addedsuccessfully: '添加成功',
  adding: '添加中...',
  deleting: '刪除中...',
  Areyousuretodeletethislisteninggroup: '確認刪除該監聽群組嗎？',
  GPSison: 'GPS已開啟，重啟設備生效！',
  GPSisoff: 'GPS已關閉，重啟設備生效！',
  Doyouwanttocontinue: '勾選用戶中存在定位卡未過期的用戶，是否繼續？',
  Renewalsuccessful: '續費成功！',
  IMEIdoesnotexist: 'IMEI不存在',
  Insufficientservicecardbalance: '服務卡餘額不足',
  andtheterminalneedstoberestarted: '修改所屬公司成功，需要重啟設備',
  Modifytheaffiliatedunitsuccessfully: '修改所屬公司成功',
  rOrg_tips: '公司名稱應為4-20位中文、數字、字母、底線，不能以底線開頭',
  rNamep_tips: '應為 2-10位中文、數字、字母、底線，不能以底線開頭',
  rNamep_tips20: '應為 2-20位中文、數字、字母、底線，不能以下劃線開頭',
  rPhone_tips: '手機號碼格式不正確',
  rAgent_tips: '代理商名稱應為 4-20位中文、數字、字母、底線，不能以底線開頭',
  wAgent_tips: '稱由1-15位中文，數字，字母，底線組成，且不能以底線開頭',
  rGroup_tips: '群組名稱應為2-15位中文、數字、字母',
  rGroup2_tips: '群組名稱由2-12位數字，中文，英文組成',
  rAccount_tips: '帳號由6-20位英文、數字和底線組成',
  rPwd_tips: '密碼應為6-16位字母、數字組成',
  rName_tips: '應為 2-7位中文、數字、字母、底線，不能以底線開頭',
  rNamep1_tips: '使用者暱稱由2-30個字元組成',
  rEmail_tips: '請輸入正確格式的郵件地址',
  rInt_tips: '請輸入正整數',
  rInputNum_tips: '請輸入數字',
  rBroad_tips: '輸入內容應為中文、數字、英文字母',
  rVerifyCode_tips: '手機驗證碼為4位數字',
  rICCID_tips: 'ICCID應為19或20位英文字母或數字組成',
  rIMEI_tips: 'IMEI應為15位數字組成',
  removegroupleader: '確認移除群主自動刪除此自建群組嗎？',
  removeselfcreatedgroups: '確認移除自建群組並自動刪除嗎？',
  removeselfcreatedgroupsTow: '確定要改變用戶所屬公司並自動刪除用戶自建群組嗎？',
  PleaseselectSOS: '請選擇未開啟SOS服務的用戶',
  Logintimedout: '登錄超時！',
  Serverconnectionexception: '伺服器連接異常',
  ServerconnectionexceptionLoaing: '載入中',
  Nolocationtrack: '沒有位置軌跡',
  Areyousuretodeletethemember: '確認刪除該成員嗎',
  update_successfully: '更新成功',
  updatecompleted: '更新成功',
  Pleaseselecttheexportdaterange: '請選擇匯出日期區間，最近90天',
  Thestarttimecannotbegreaterthantheendtime: '開始時間不能大於、等於結束時間',
  Theendtimecannotbelessthanthestarttime: '結束時間不能小於、等於開始時間',
  Areyousureyouwanttodeletethisfence: '確認刪除該圍欄嗎？',
  Thefencenameisduplicated: '圍欄名稱重複，請修改後重試',
  setptttips: '請選擇服務期限',
  Pleaseselectareareplacement: '請選擇區域更換',
  Successfuloperation: '操作成功',
  Areyousuretoresettheuserpassword: '確定恢復該用戶密碼嗎？',
  selectedvipcardTpis: '選中的VIP卡用戶充值錄音、定位、SOS、圍欄服務卡會自動過濾',
  selectedpttgpscardTpis: '選取的PTT+GPS用戶儲值定位服務卡會自動過濾',
  closeAgentTips: '關閉後下級代理商用戶不會顯示該服務相關資訊，服務期內的用戶可繼續使用服務，確定關閉嗎？',
  vipCardNoTips: 'VIP卡用戶的錄音、定位、 SOS、 電子圍欄功能都為永久，不需要啟動',
  pttCardNoTips: '暫無服務卡需要啟動',
  pointtips1: '已開啟用戶單呼功能',
  pointtips2: '已關閉用戶單呼功能',
  LimitspecifiedEnglish: 'select、update、and、or、delete、insert、trancate、char、chr、into、substr、ascii、declare、exec、count、master、drop、execute、script、iframe字段',
  Thecommentcontentcannotcontain: '備註內容不能包含',
  Theagentsremarkscannotcontain: "代理商備註內容不能包含",
  theagencynamecannotcontain: '代理商名稱不能包含',
  Thecompanynamecannotcontain: '單位名稱不能包含',
  Thegroupnamecannotcontain: '群組名稱不能包含',
  Usernamecannotcontain: '使用者名稱不能包含',
  Registeredsuccessfully:'註冊成功',
  UnbindingUserTips:'解綁後用戶會清除所有公司群組數據，終端無法登錄，是否確定解綁?',
  Failedtocreategrouppleasebinddevicefirst:'建立群組失敗，請先綁定設備',
  Devicebindingsuccessful:'设备绑定成功',
  Devicebindingfaileddifferentownership:'设备绑定失败，不同归属',
  Devicebindingfailedaccountdoesnotexist:'设备绑定失败，账号不存在',
  Devicebindingfailedalreadybound:'设备绑定失败，已绑定',
  Devicebindingfailedalreadyexists:'设备绑定失败，已存在',
  The_maximum_duration_can_only_be_set_to_60_minutes:'最大隻能設定60分鐘',
  SOS_transmission_interval:'SOS發送間隔',
  Please_set_the_SOS_interval:'請設定SOS間隔時間',
  recyclingServiceCardTips:'確定回收後，該用戶會被刪除，消耗的服務卡會被回收',
  Pleasebindthedevicefirst:'請先綁定裝置'
}
